import { useLang } from "../../lib/i18n";
import { adhdCopy } from "../../lib/i18n/adhd";

// ADHDPill — the "SPOKÓJ · ON/OFF" toggle (design handoff §"Reusable atoms").
// Used twice: as an overlay on the full Home (off) and inside the ADHD
// variants (on). Optional palette overrides let variant B's `stop` state
// tint the pill so it stays legible on a dark background.
type Props = {
  on: boolean;
  onToggle: () => void;
  // Palette overrides (variant B states). Default to the global tokens.
  inkColor?: string;
  bgColor?: string;
  mutedColor?: string;
};

export function AdhdPill({ on, onToggle, inkColor, bgColor, mutedColor }: Props) {
  const { lang } = useLang();
  const t = adhdCopy[lang];
  const ink = inkColor ?? "var(--ink)";
  const bg = bgColor ?? "var(--bg)";
  const muted = mutedColor ?? "var(--ink-2)";
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-pressed={on}
      aria-label={on ? t.pillAriaOn : t.pillAriaOff}
      className="inline-flex items-center transition-colors"
      style={{
        gap: 7,
        padding: "5px 10px 5px 7px",
        borderRadius: 99,
        border: "none",
        background: on ? ink : "transparent",
        color: on ? bg : muted,
        boxShadow: on ? "none" : "0 0 0 1px var(--nav-border)",
        fontFamily: "var(--font-mono)",
        fontSize: 9,
        fontWeight: 700,
        letterSpacing: "0.06em",
        lineHeight: 1,
      }}
    >
      <span
        aria-hidden
        style={{
          width: 12,
          height: 12,
          borderRadius: 99,
          background: on ? "var(--accent)" : "var(--track)",
        }}
      />
      {t.pillLabel} {on ? t.pillOn : t.pillOff}
    </button>
  );
}
